// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const nric: CountryValidator<"MY", ParsedPersonId> =
  createValidator("my.nric", 131);

export default nric;
export const compact = nric.compact;
export const format = nric.format;
export const validate = nric.validate;
export const generate = (): string =>
  nric.generate?.() ??
  (() => {
    throw new Error(
      "Validator my.nric cannot generate values",
    );
  })();
export const parse = nric.parse;
